import axios from 'axios'
//import qs from 'qs'
import router from './router';
import { GetUrlParam } from '@/utils/filter'
// import {set, get} from '@/utils/localStorage'
// 创建axios实例

// console.log(GetUrlParam('access_token'));
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store';


const service = axios.create({
        baseURL: '/api',
        //timeout: 100000, // 请求超时时间
        //data:data,
        // transformRequest: [function (data) {
        //     return qs.stringify(data);
        // }],
        //withCredentials:false,
        headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
            // 'content-type': "application/json;charset=UTF-8"
        }

    })
    // request拦截器
service.interceptors.request.use(
    config => {
        // let localdata = get('userinfo');
        // //console.log(localdata);
        if (config.url == "/me") {
            if (GetUrlParam('access_token') && GetUrlParam('access_token') !== undefined) {
                config.headers["Authorization"] = 'bearer ' + GetUrlParam('access_token')
            }
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// respone拦截器
service.interceptors.response.use(
    response => {
        return response
    },
    error => {
        console.log(error.response);
        if (error.response.data.code == 401) {
            if (error.response.config.url !== "/me") {
                router.replace({ path: "/" })
            }
        }
        return Promise.reject(error.response.data)
    }
)
export default service